import AbstractSystem from "../all/AbstractSystem";

class AndroidTVSystem extends AbstractSystem {
    constructor() {
        super();
        this.device = undefined;
        this.document = undefined;
    }

    exit() {
        try {
            window.AndroidPlayerInterface.onExitApp();
        }
        catch(err) {
            console.log('[AndroidTV] exit > onExitApp error:', err);
        }
    }

    getDisplayResolution() {
        //the display resolution in workstation are 1280p and 1080p
        const config = window.config;
        var resolution1080p = config.get("device.workstation.1080p", false);
        if (resolution1080p) {
            return {
                width: 1920,
                height: 1080
            };
        }
        return {
            width: 1280,
            height: 720
        };
    }

    supportSSL() {
        return true;
    }

    redraw(element) {
        return false;
    }
}

export default AndroidTVSystem;



// WEBPACK FOOTER //
// ./src/devices/androidtv/System.js